<div
  [innerHtml]="element.twitterHtml | safeHtml"
  class="cosmos-twitter-element-preview__wrapper"
></div>
